// src/vocabulary/A2/unit1/content.js

const content = {
  level: "A2",
  unit: 1,
  title: "Home & Daily Objects",
  description:
    "Common rooms, furniture, and objects you use at home. Learn how to describe your home and daily activities.",

  explanation: [
    "This unit helps you talk about your home and the things inside it.",
    "You will learn words for rooms, furniture, and common household objects.",
    "These words are often used with 'there is' and 'there are'.",
    "For example: There is a table in the kitchen. There are two chairs in the room.",
    "You can also use these words to describe where things are.",
    "For example: The lamp is next to the bed.",
    "Talking about your home is very common in daily conversations.",
    "Try to describe your own home using these words and simple sentences."
  ],

  items: [
    {
      word: "kitchen",
      phonetic: "/ˈkɪtʃɪn/",
      meaning: "مطبخ",
      example: "The kitchen is next to the living room."
    },
    {
      word: "bedroom",
      phonetic: "/ˈbedruːm/",
      meaning: "غرفة نوم",
      example: "My bedroom is small but comfortable."
    },
    {
      word: "living room",
      phonetic: "/ˈlɪvɪŋ ruːm/",
      meaning: "غرفة المعيشة",
      example: "We watch TV in the living room."
    },
    {
      word: "table",
      phonetic: "/ˈteɪbəl/",
      meaning: "طاولة",
      example: "The table is in the kitchen."
    },
    {
      word: "sofa",
      phonetic: "/ˈsoʊfə/",
      meaning: "أريكة",
      example: "She is sitting on the sofa."
    },
    {
      word: "lamp",
      phonetic: "/læmp/",
      meaning: "مصباح",
      example: "The lamp is next to the bed."
    },
    {
      word: "cupboard",
      phonetic: "/ˈkʌbərd/",
      meaning: "خزانة",
      example: "The cups are in the cupboard."
    }
  ]
};

export default content;


